import { FC } from 'react'

import { useSelector } from 'react-redux'
import { Route, Routes, Navigate } from 'react-router'

import { LoginPage } from 'src/Pages/LoginPage'
import { PageLayout } from 'src/Components/PageLayout'
import { CalculatorPage } from 'src/Pages/Calculator'
import { TransportPage } from 'src/Pages/Transport'
import { OffersPage } from 'src/Pages/Offers'
import { ToolsPage } from 'src/Pages/Tools'
import { SettingsPage } from 'src/Pages/SettingsPage'
import { CreateContractPage } from 'src/Pages/CreateContractPage'
import { ContractsPage } from 'src/Pages/ContractsPage'
import { Clients } from 'src/Pages/Clients'
import { RootState } from 'src/Redux'
import { TransportSettingsPage } from 'src/Pages/TransportSettingsPage'
import { InboxPage } from 'src/Pages/InboxPage'
import { UsersPage } from 'src/Pages/Users'

import { RoutesEnum } from './types'

export const Router: FC = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.authentication.isAuthenticated,
  )

  if (!isAuthenticated) return <LoginPage />

  return (
    <Routes>
      <Route
        path={RoutesEnum.ROOT}
        element={<Navigate to={RoutesEnum.TRANSPORTS} replace />}
      />
      <Route
        path={RoutesEnum.TRANSPORTS}
        element={
          <PageLayout>
            <TransportPage />
          </PageLayout>
        }
      />
      <Route
        path={`${RoutesEnum.OFFERS}${RoutesEnum.NEW}`}
        element={
          <PageLayout>
            <CalculatorPage />
          </PageLayout>
        }
      />
      <Route
        path={`${RoutesEnum.OFFERS}/:id`}
        element={
          <PageLayout>
            <CalculatorPage />
          </PageLayout>
        }
      />
      <Route
        path={RoutesEnum.CLIENTS}
        element={
          <PageLayout>
            <Clients />
          </PageLayout>
        }
      />
      <Route
        path={RoutesEnum.OFFERS}
        element={
          <PageLayout>
            <OffersPage />
          </PageLayout>
        }
      />
      <Route
        path={RoutesEnum.TOOLS}
        element={
          <PageLayout>
            <ToolsPage />
          </PageLayout>
        }
      />

      <Route
        path={RoutesEnum.SETTINGS}
        element={
          <PageLayout>
            <SettingsPage />
          </PageLayout>
        }
      />

      <Route
        path={RoutesEnum.TRANSPORT_SETTINGS}
        element={
          <PageLayout>
            <TransportSettingsPage />
          </PageLayout>
        }
      />

      <Route
        path={`${RoutesEnum.CONTRACTS}`}
        element={
          <PageLayout>
            <ContractsPage />
          </PageLayout>
        }
      />

      <Route
        path={`${RoutesEnum.CONTRACTS}${RoutesEnum.NEW}/:offerId`}
        element={
          <PageLayout>
            <CreateContractPage />
          </PageLayout>
        }
      />

      <Route
        path={RoutesEnum.INBOX}
        element={
          <PageLayout>
            <InboxPage />
          </PageLayout>
        }
      />

      <Route
        path={RoutesEnum.USERS}
        element={
          <PageLayout>
            <UsersPage />
          </PageLayout>
        }
      />
    </Routes>
  )
}
